var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#343A40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.806 18.082H2.773c-2.746 0-2.886 1.722-2.73 3.836L2.06 56.164C2.2 58.26 2.603 60 5.334 60H54.4c2.793 0 3.12-1.722 3.274-3.836l1.878-34.676c.14-2.096 0-3.406-2.747-3.406zM55.915 8.75c-.077-2.293-.7-2.829-2.349-2.829H31.288c-3.392 0-3.796.056-6.363-3.216-2.132-2.736-1.291-2.7-5.694-2.7H7.516c-2.707 0-3.672-.277-3.92 3.07-.234 3.086-.778 10.573-.856 11.72h53.424l-.249-6.045z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.5c9e5cac50304c94ff347bc1cdf6d31c.svg";
export { ForwardRef as ReactComponent };